import { FC, ReactNode } from 'react';

const DealRoomCard: FC<{ children?: ReactNode }> = ({ children }) => (
  <div className="text-slate-400">{children}</div>
);

export { DealRoomCard };
